const tables = [
  { name: "Period" },
  {name : "Branch" }, 
  { name: "Opening Balance" },
  { name: "Total Debit" },
  { name: "Total Credit" },
  { name: "Closing Balance" },
  { name: "Status" },
  { name: "Action" },
];

export default tables;